import { lazy } from 'react';
import PropTypes from "prop-types";
import { NEWSLETTER_POPUP_ID } from './NewsletterSubscription.config';
import Popup from 'Component/Popup';
import Form from 'Component/Form';
import CmsBlock from 'Component/CmsBlock';
import { DeviceType } from 'Type/Device';
import { appendWithStoreCode } from 'Util/Url';
import Cookies from "universal-cookie";

export const CloseIcon = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "icons" */ 'Component/CloseIcon'));

import { NewsletterSubscription as SourceNewsletterSubscription } from 'SourceComponent/NewsletterSubscription/NewsletterSubscription.component';

export class NewsletterSubscription extends SourceNewsletterSubscription {
    cookies = new Cookies();

    static propTypes = {
        onFormSubmit: PropTypes.func.isRequired,
        openNewsletterPopup: PropTypes.func.isRequired,
        setNewsletterPopupCookie: PropTypes.func.isRequired,
        device: DeviceType.isRequired,
        isLoading: PropTypes.bool.isRequired,
        isAgreed: PropTypes.bool.isRequired,
        hideSticky: PropTypes.bool.isRequired,
        showError: PropTypes.bool.isRequired
    };

    get fieldMap() {
        const fields = {
            newsletterEmail: {
                validation: ['notEmpty', 'email'],
                placeholder: __('abc12345@email.com'),
                label: __('Email'),
                ariaLabel: __('Email')
            }
        };

        return fields;
    }

    renderNewsletterPopupStickyButton() {
        const {
            openNewsletterPopup,
            setNewsletterPopupCookie,
            hideSticky,
            device
        } = this.props;

        if(hideSticky || device.isMobile || this.cookies.get('sticky_newsletter_hide_cookie')) {
            return null
        }

        return (
            <div className="NewsletterSubscription-StickyContainer">
                <div
                    block="NewsletterSubscription"
                    elem="StickyButton"
                    onClick={ openNewsletterPopup }
                >
                    <span>{ __('Newsletter') }</span>
                </div>
                <div
                    block="NewsletterSubscription"
                    elem="StickyClose"
                    onClick={ setNewsletterPopupCookie }
                >
                    <CloseIcon />
                </div>
            </div>
        );
    }

    renderNewsletterPopupButton() {
        const {
            openNewsletterPopup
        } = this.props;

        return (
            <button
                block="Button"
                mods={ { isHollow: true } }
                mix={ { block: 'NewsletterSubscription', elem: 'PopupButton' } }
                onClick={ openNewsletterPopup }
            >
                <span>{ __('Εγγραφή στο Newsletter') }</span>
            </button>
        );
    }

    renderActions() {
        return (
            <button
                type="submit"
                block="Button"
                mods={ { isHollow: true } }
                aria-label={ __('Submit') }
            >
                { __('Εγγραφη') }
            </button>
        );
    }

    renderContent() {
        const { isAgreed, showError, isAgreedStatus, isLoading, onFormSubmit, onSubscribeEmailAttempt } = this.props;

        return (
            <Popup
                id={ NEWSLETTER_POPUP_ID }
                clickOutside={ false }
                mix={ { block: 'NewsletterPopup' } }
            >
                <div block="NewsletterSubscription">
                    <CmsBlock identifier={ 'newsletter_popup_left_block' } />
                    <Form
                        onSubmit={onSubscribeEmailAttempt}
                        onSubmitSuccess={ onFormSubmit }
                        mix={ { block: 'FieldForm' } }
                    >
                        <div className="NewsletterSubscription-title" >{ __('ΕΓΓΡΑΦΗ ΣΤΟ NEWSLETTER') }</div>
                        <div block="FieldForm" elem="Fieldset" mods={ { isLoading } }>
                            { this.renderFields() }
                            <div className="subscribe-form__checkbox">
                                <label
                                    className="checkradio checkradio_light checkradio_radio"
                                >
                                    <input
                                        className="checkradio__input"
                                        name="agree"
                                        value="agree"
                                        type="checkbox"
                                        onChange={isAgreedStatus}
                                    />
                                    <span className="checkradio__box"></span>
                                    <span className="checkradio__content">
                                        { __('Αποδέχομαι τους ') }
                                        <a href={appendWithStoreCode("/politiki-prostasias-prosopikon-dedomenon-kai-aporritou")} target="_blank">{ __('Όρους & Προϋποθέσεις') }</a>
                                    </span>
                                </label>
                                {
                                    !isAgreed && showError ?
                                        <p className="Field-Message">{ __('please agree with the terms and conditions') }</p>
                                        : ""
                                }
                            </div>
                            { this.renderActions() }
                        </div>
                    </Form>
                </div>
            </Popup>
        );
    }

    render() {
        return (
            <>
                { this.renderNewsletterPopupStickyButton() }
                { this.renderNewsletterPopupButton() }
                { this.renderContent() }
            </>
        );
    }
}

export default NewsletterSubscription;
